import MarkdownEditLazy from "./edit-lazy"
// import MarkdownEditor from "./edit"
import MarkdownView from "./view"
// import MarkdownBlockEdit from "./MarkdownEditor"

export default { view: MarkdownView, edit: MarkdownEditLazy }
